import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Directive({
  selector: '[restrictNumberDecimal]'
})
export class RestrictNumberDecimalDirective {

  constructor(private elementRef: ElementRef,
    private control: NgControl,
    private utilityService: UtilityService,
    ) {
   }

  @HostListener('blur', ['$event']) onInputChange(event): any {
    const initialValue = this.elementRef.nativeElement.value;
    const companyDecimalValue = this.utilityService.companyConfig?.general?.decimal_roundoff || 2;
    const hasSellingPrice = this.elementRef.nativeElement?.classList?.contains('selling-price');
    if (initialValue >= 0 || hasSellingPrice) {
      if (initialValue.indexOf('.') !== -1) {
        const wholeNumber = initialValue?.toString()?.split('.')[0];
        const decimalNumber = initialValue?.toString()?.split('.')[1];
        if (decimalNumber && decimalNumber?.toString()?.length > companyDecimalValue) {
          const updatedDecimalValue = decimalNumber.substring(0, companyDecimalValue);
          this.elementRef.nativeElement.value = wholeNumber.concat('.', updatedDecimalValue);
          event.stopPropagation();
        } else if(hasSellingPrice) {
          this.elementRef.nativeElement.value = initialValue;
        }
      } else if(hasSellingPrice) {
        this.elementRef.nativeElement.value = initialValue;
      }
    } else {
      if(this.control?.control){
        this.control.control.setValue(null);
      }else{
        this.elementRef.nativeElement.value = null;
      }
      event.stopPropagation();
    }
  }

}
